var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('div',{ref:"map",staticClass:"map"}),_c('div',{staticClass:"coordinates"},[_vm._v(" 經度: "+_vm._s(_vm.currentCenter.lng.toFixed(6))+", 緯度: "+_vm._s(_vm.currentCenter.lat.toFixed(6))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }